import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-homeTeacherSmallIcon",
  "use": "icon-homeTeacherSmallIcon-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-homeTeacherSmallIcon\">\n<path d=\"M17.7601 33.7697L10.5601 38.2801C13.3734 40.1867 20.1 44 24.5 44C28.9 44 34.96 40.1867 37.4401 38.2801L30.0001 33.7697V22.5601C30.0001 19.1801 27.26 16.4401 23.8801 16.4401C20.5001 16.4401 17.7601 19.1801 17.7601 22.5601V33.7697Z\" fill=\"#4570FB\" />\n<circle cx=\"24\" cy=\"24\" r=\"20\" stroke=\"#25282B\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/homeTeacherSmallIcon.svg
// module id = lpng
// module chunks = 10